import React from 'react'
import "./PlainBgText.css"
import { useNavigate } from 'react-router-dom'

function PlainBgText() {
  const navigate = useNavigate()
  return (
    <div className='PlainBgText-container standard-padding-space'>
        <div className='container my-5'>
            <div className='text-center'>
                <h5 className='sub-heading mb-3 font-atwick' style={{fontWeight:"bolder",fontSize:"2rem",letterSpacing:"1px",fontFamily:"atwic",textTransform:"none"}}>Lotus Accounting</h5>
                <h3 className='body-heading mx-auto'>Are You or Your Business Paying More Tax Than Necessary?</h3>
                <p className='body-paragraph px-lg-5 px-auto mt-3'>Whether it’s personal or corporate, tax laws are complex—and without expert guidance, you could be missing out on valuable savings. At Lotus Accounting, we help individuals and business owners uncover overlooked deductions and implement smart tax strategies to reduce what you owe, legally and effectively.</p>
                <p className='body-paragraph px-lg-5 px-auto mt-3'><b>Stop Overpaying. Book Your Comprehensive Tax Review Today.</b></p>
                {/* <button className='blue-btn mt-4' onClick={()=>{navigate("/contact")}}>BOOK A CONSULTATION</button> */}
                <button className='blue-btn mt-4' onClick={()=>{window.open("https://calendly.com/chandrancpa","blank")}}>BOOK A CONSULTATION</button>
            </div>
        </div>
    </div>
  )
}

export default PlainBgText